import { Navbar, Footer } from "@/components/Layout";
import { useSeo } from "@/hooks/useSeo";

export default function Terms() {
  useSeo({
    title: "Användarvillkor",
    description: "Användarvillkor för TimberNet — regler för köpare, säljare och tjänsteleverantörer på Sveriges digitala marknadsplats för skog.",
    path: "/villkor",
  });
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="container max-w-3xl flex-1 py-8">
        <h1 className="mb-6 font-display text-2xl font-bold md:text-3xl">Användarvillkor</h1>
        <div className="prose prose-sm max-w-none text-muted-foreground space-y-4 text-sm leading-relaxed">
          <p>Dessa villkor gäller för användning av TimberNets plattform. Genom att använda tjänsten godkänner du dessa villkor.</p>
          <h2 className="font-sans text-lg font-semibold text-foreground">Tjänsten</h2>
          <p>TimberNet är en digital marknadsplats som förmedlar kontakt mellan köpare, säljare och tjänsteleverantörer inom skog och virke.</p>
          <h2 className="font-sans text-lg font-semibold text-foreground">Ansvar</h2>
          <p>TimberNet ansvarar inte för kvaliteten på tjänster utförda av leverantörer. Vi tillhandahåller plattformen för förmedling.</p>
          <h2 className="font-sans text-lg font-semibold text-foreground">Betalning & avgifter</h2>
          <p>Transaktionsavgifter debiteras vid genomförd betalning. Aktuella avgifter visas i samband med bokning eller köp.</p>
          <h2 className="font-sans text-lg font-semibold text-foreground">Tvistelösning</h2>
          <p>Vid tvister mellan parter kan TimberNet bistå med medling. Svensk lag tillämpas.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
